export const junipKey = process.env.NEXT_PUBLIC_JUNIP_STORE_KEY

export const fetcher = (url: string) =>
  fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Junip-Store-Key': junipKey,
    } as any,
  }).then((res) => res.json())
